
let language = {
    RENAME_FOLDER_RENAME_FOLDER_TITLE: "Rename folder",
    RENAME_FOLDER_FOLDER_NAME_LABEL: "Folder Name",

    // 
    RENAME_FOLDER_CANCEL_BTN: "Cancel",
    RENAME_FOLDER_RENAME_BTN: "Rename",


    RENAME_FOLDER_RENAME_PATTERN_TIP: "The file name cannot contain the following characters: \\ \/ \: \* \? \" \< \> \|",
};

export { language }